export default __webpack_public_path__ + "static/media/takedownForm.19d20025.doc";